import _ from 'lodash';
import history from 'config/history';

export const reverse = (url, args) => {
  _.forEach(args, (value, key) => {
    const pattern = new RegExp(`:${key}`, 'g');
    url = url.replace(pattern, value);
  });

  return url;
};

export const parseUrlPath = (url: string) => {
  return _.first(url.split('?'));
};

export const parseGetParamsForUrl = (url: string) => {
  const getParams = _.get(url.split('?'), '[1]', '');

  return parseGetParams(getParams);
};

export const parseGetParams = query => {
  const result = {};
  let substringIndex = 0;

  if (query.startsWith('?')) {
    substringIndex = 1;
  }

  query
    .substring(substringIndex)
    .split('&')
    .filter(param => !_.isEmpty(param))
    .forEach(param => {
      const parts = param.split('=');
      result[parts[0]] = decodeURI(parts[1]);
    });

  return result;
};

export const getFullUrlPath = (domain, params) => `${domain}?${params}`;

export const buildUrlFromNextRedirect = url => {
  const params = parseGetParams(url);

  const originalUrl = _.get(params, '_next', '');

  if (_.keys(params).length < 2) {
    return originalUrl;
  }

  const paramsToQuery = toGetQuery(_.omit(params, ['_next']));
  return getFullUrlPath(originalUrl, paramsToQuery);
};

export const setUrlQuery = query => {
  history.replace({search: query});
};

export const getUrlQuery = () => {
  return history.location.search;
};

export const parseGetQuery = query => {
  return parseGetParams(query);
};

export const toGetQuery = params => {
  return Object.keys(params)
    .map(param => {
      const key = _.camelCase(param);
      const value = encodeURI(params[param]);

      return `${key}=${value}`;
    })
    .join('&');
};

/*
Expects to have the newParams that need to be removed as `null` or `""` in order to remove them from the url
*/
export const updateCurrentUrlParams = newParams => {
  const currentParams = parseGetQuery(getUrlQuery());

  const newObject = _.pickBy(
    {
      ...currentParams,
      ...newParams
    },
    value => !_.isNil(value) && value !== ''
  );

  setUrlQuery(toGetQuery(newObject));
};

export const getURLParams = () => {
  return history.location.search;
};
